import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { addMessage } from '../../../Redux/Actions/MessageActions/';

import {
  StyledForm,
  StyledFormTitle,
  StyledFormLabel,
  StyledErrors,
  StyledCloseIcon,
  StyledConfirmButtons,
} from './StyledForm';

import { MoreButton } from '../Buttons';

export const Form = ({
  title,
  submitFn = () => null,
  entered = false,
  elements = [],
  button = null,
  closeButton = false,
  closeFn = () => null,
  formdata = null,
  active = true,
  setActivated = () => null,
  allowPatch = false,
  styles = {},
}) => {
  const [formData, setFormData] = useState(
    formdata ||
      elements.reduce((acc, { options }) => {
        acc[options.name] = '';
        return acc;
      }, {}),
  );
  const [changedFormData, setChangedFormData] = useState({});
  const [errors, setErrors] = useState({});

  const [openedSelect, setOpenedSelect] = useState(null);

  const handleOpen = index => () =>
    active && setOpenedSelect(openedSelect === index ? null : index);

  const { loading, success, error } = useSelector(({ message }) => message);
  const dispatch = useDispatch();

  const handleInput = name => (value, err) => {
    if (name) {
      setFormData({ ...formData, [name]: value });
      allowPatch && setChangedFormData({ ...changedFormData, [name]: value });
      if (err) {
        setErrors({ ...errors, [name]: err });
      } else if (name in errors) {
        setErrors(prev => {
          delete prev[name];
          return prev;
        });
      }
    }
  };

  const handleSubmit = async e => {
    dispatch(addMessage({ error: '', success: '' }));
    console.log('form', formData);
    setOpenedSelect(null);
    if (!active) return;
    e.preventDefault();
    //e.nativeEvent.submitter.style.pointerEvents = 'none';
    if (Object.values(errors).length)
      return dispatch(addMessage({ error: 'ištaisyti klaidas' }));
    if (
      Object.values(formData).filter(el => el).length === elements.length ||
      allowPatch
    ) {
      await submitFn(e, allowPatch ? changedFormData : formData);
    } else dispatch(addMessage({ error: 'užpildykite formos laukus' }));
  };

  const handleClickButton = e => {
    e.stopPropagation();
    if (!active) {
      e.preventDefault();
      dispatch(addMessage({ loading: false, error: '', success: '' }));
      setActivated(true);
    }
  };

  useEffect(() => {
    dispatch(addMessage({ loading: false, error: '', success: '' }));
    return () =>
      dispatch(addMessage({ loading: false, error: '', success: '' }));
  }, [dispatch]);

  return (
    <StyledForm
      className={entered ? 'entered' : ''}
      onSubmit={handleSubmit}
      style={styles}
    >
      {closeButton && <StyledCloseIcon onClick={closeFn} />}
      <StyledFormTitle>{title}</StyledFormTitle>
      <ul>
        {elements.map(
          (
            {
              Element,
              options: {
                name = '',
                label = '',
                options = null,
                setOptions,
                ...props
              },
            },
            i,
          ) => {
            const { fn, params, transform } = setOptions || {
              fn: () => null,
              params: [],
              transform: () => null,
            };
            const opts = options || transform(fn(...params));
            return (
              <li key={i} onClick={handleOpen(i)}>
                {!!label && <StyledFormLabel>{label}</StyledFormLabel>}
                <Element
                  {...props}
                  name={name}
                  fn={handleInput(name)}
                  value={formData[name]}
                  selected={formData[name]}
                  open={openedSelect === i}
                  options={opts}
                  className={
                    formData[name]?.length
                      ? 'correct form__input'
                      : 'form__input'
                  }
                  disabled={!active}
                />
              </li>
            );
          },
        )}
        {!!button && (
          <li style={button.containerStyle}>
            <MoreButton
              wd={button.wd}
              fn={handleClickButton}
              text={active ? button.text : button.inactiveText}
              butType={button.butType || 'gold'}
              loading={loading}
            />
            <StyledErrors>
              <span className={error ? 'error' : ''}>{error || ''}</span>
              <span className={success ? 'success' : ''}>{success || ''}</span>
              <span className={loading ? 'spinner loading' : 'spinner'}></span>
            </StyledErrors>
          </li>
        )}
      </ul>
    </StyledForm>
  );
};

export const ConfirmForm = ({
  title,
  submitFn = () => null,
  entered = false,
  button = null,
  closeButton = false,
  closeFn = () => null,
}) => {
  const { loading, success, error } = useSelector(({ message }) => message);
  const dispatch = useDispatch();

  const handleSubmit = async e => {
    dispatch(addMessage({ error: '', success: '' }));
    e.preventDefault();
    e.nativeEvent.submitter.style.pointerEvents = 'none';
    await submitFn(e);
  };

  const handleCloseButton = e => {
    e.preventDefault();
    closeFn();
    dispatch(addMessage({ loading: false, error: '', success: '' }));
  };

  useEffect(() => {
    dispatch(addMessage({ loading: false, error: '', success: '' }));
    return () =>
      dispatch(addMessage({ loading: false, error: '', success: '' }));
  }, [dispatch]);

  return (
    <StyledForm className={entered ? 'entered' : ''} onSubmit={handleSubmit}>
      {closeButton && <StyledCloseIcon onClick={closeFn} />}
      <StyledFormTitle>{title}</StyledFormTitle>
      <ul>
        {button && (
          <li>
            <StyledConfirmButtons>
              <li>
                <MoreButton
                  wd={button.wd}
                  fn={handleCloseButton}
                  text="Ne"
                  butType={'gold'}
                />
              </li>
              <li>
                <MoreButton
                  wd={button.wd}
                  text="Taip"
                  butType={button.butType || 'white-UC'}
                  loading={loading}
                />
              </li>
            </StyledConfirmButtons>
            <StyledErrors>
              <span className={error ? 'error' : ''}>{error || ''}</span>
              <span className={success ? 'success' : ''}>{success || ''}</span>
              <span className={loading ? 'spinner loading' : 'spinner'}></span>
            </StyledErrors>
          </li>
        )}
      </ul>
    </StyledForm>
  );
};
